export default __webpack_public_path__ + "static/media/service2-min.751967b9.png";